export function parseId(entity, id) {
    return (entity.parseId?.(id) ?? id);
}
//# sourceMappingURL=parseId.js.map